<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row">
        <div class="col-12">
          <h2 class="text-start">Sites</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3 ms-auto">
          <button
            class="btn btn-primary w-100"
            @click="goToCreateNewSite">
            <i class="bi bi-plus-circle-fill"></i> Create New Site
          </button>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-lg-4 mb-4">
            <ca-smtt-input
              type="text"
              label="Search"
              placeholder="Search sites by name"
              iconClear
              @clearInput="(e) => this.sitesSearchOptions = e"
              @input="handleSearchSites"
            />
          </div>
        </div>
        <div class="row"
          v-if="filteredSites.length === 0"
        >
          <div class="col-12 text-uppercase">
            sites not found
          </div>
        </div>

        <div
          v-else
          class="row"
          :class="{
            'px-4': mobileDisplay
          }"
        >
          <table
            class="table table-responsive table-hover text-start rounded-3"
          >
            <thead id="table-headers" class="table-primary">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Site Type</th>
                <!-- <th scope="col">URL</th> -->
                <th scope="col" class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody id="table-body">
              <tr
                class="text-start cursor-pointer m-0 p-0"
                v-for="(site, index) in filteredSites" :key="index"
                :title="`Go to ${site.site} details`"
              >
                <td header="Name" scope="row" class="word-wrap"> {{ site.site ? site.site : '<TBD>' }} </td>
                <td header="Description"> {{ site.site_text ? site.site_text : 'No site description'}} </td>
                <td header="Site Type"> {{ site.type_site ? site.type_site.type : 'No site type' }} </td>
                <!-- <td header="URL">
                  <a
                    v-if="linkRegExp.test(site.web_url)"
                    :href="site.web_url"
                    class="text-decoration-none"
                    target="_BLANK">
                    Open external
                  </a>
                  <p v-else>
                    Resource to be uploaded
                  </p>
                </td> -->
                <td header="Actions" class="d-flex justify-content-start justify-content-xl-evenly">
                  <button
                    class="btn btn-label"
                    title="Edit"
                    @click="goToEditSite($event, site.id)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    class="btn btn-label"
                    title="Delete"
                    @click="handleDeleteSite($event, site)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                  <button
                    class="btn btn-label"
                    :title="site.is_available ? 'Site enabled' : 'Site disabled'"
                    @click="toggleSiteAvailability($event, site)"
                  >
                    <i v-if="site.is_available" class="bi bi-toggle-on"></i>
                    <i v-else class="bi bi-toggle-off"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import caSmttInput from '@/components/ca-smtt-input.vue'
import { getSites } from '@/services/sites/site.api.js'
import { updateSite } from '@/services/sites/site.api.js'
import { mapState } from 'vuex'

export default {
  components: { caSmttInput },
  name: 'Home',
  data() {
    return {
      users: [],
      sites: [],
      sitesTypes: [],
      userSearchOptions: [],
      sitesSearchOptions: [],
      sitesTypesSearchOptions: [],
      dropdownText: null,
      linkRegExp: /^(ftp|http|https):\/\/[^ "]+$/,
    }
  },
  async mounted() {
    await this.showSitesTable();
  },
  methods: {
    async showSitesTable(){
      this.dropdownText = 'Sites'
      this.$store.commit('setMainScreenDropdown', 'Sites')
      this.users = []
      this.sitesTypes = []
      try {
        const {data} = await getSites()
        console.log('Sites data =>', data.sites)
        this.sites = data.sites
      } catch (error) {
        console.log(error)
      }
    },
    async toggleSiteAvailability(event, site) {
      event.stopPropagation();
      try {
        
        const payload = {
          "is_available": !site.is_available
        }

        await updateSite(site.id, payload)
        
        this.$toast.open({
          message: !site.is_available ? 'Site Enabled' : 'Site Disabled',
          type: 'info'
        })
        
        await this.showSitesTable()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
    goToCreateNewSite() {
      this.$router.push(`/site/create`)
    },
    goToEditSite(event, SiteId) {
      event.stopPropagation();
      this.$router.push(`/site/edit/${SiteId}`)
    },
    handleSearchSites(event) {
      this.sitesSearchOptions = event.target.value
    },
    handleDeleteSite(event, site) {
      event.stopPropagation()
      console.log(site.site)
    },
  },
  computed: {
    ...mapState(['mobileDisplay', 'user']),
    filteredSites() {
      return this.sitesSearchOptions.length > 0 ?
        this.sites.filter(site => {
          if (site.site.toLowerCase().includes(this.sitesSearchOptions.toLowerCase())) {
            return site
          }
        }
        ) :
        this.sites
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>